import {
    COMPANY_FEATURE_TOGGLE_DATA,
    COMPANY_FEATURE_TOGGLE_ERROR,
    COMPANY_FEATURE_TOGGLE_LOADING,
    COMPANY_FEATURE_TOGGLE_CONFIRMING,
} from "../constants";
import { makePrivateApiCall } from "utilities/dist/api";

export const showCompanyFeatureToggleConfirmation = confirming => ({
    type: COMPANY_FEATURE_TOGGLE_CONFIRMING,
    payload: confirming,
});

export const toggleCompanyFeature = feature => dispatch => {
    dispatch({
        type: COMPANY_FEATURE_TOGGLE_LOADING,
    });

    return makePrivateApiCall({
        url: `/company/feature`,
        method: "post",
        data: feature,
    })
        .then(res => {
            if (res.data) {
                dispatch({
                    type: COMPANY_FEATURE_TOGGLE_DATA,
                    payload: res.data,
                });
            }
        })
        .catch(err => {
            if (err?.response?.data?.message) {
                dispatch({
                    type: COMPANY_FEATURE_TOGGLE_ERROR,
                    payload: err.response.data.message,
                });
            } else {
                dispatch({
                    type: COMPANY_FEATURE_TOGGLE_ERROR,
                    payload: err.message,
                });
            }
        });
};
